import { render, staticRenderFns } from "./centro-custo.vue?vue&type=template&id=5818e03a&"
import script from "./centro-custo.vue?vue&type=script&lang=js&"
export * from "./centro-custo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports